export const EXTERNAL_EDITORS = {
  COS: 'cos',
  TICKET: 'ticket',
  VIDEO: 'video'
};